import { render, staticRenderFns } from "./AdvisorProfile.vue?vue&type=template&id=a8cacf5a"
import script from "./AdvisorProfile.vue?vue&type=script&lang=js"
export * from "./AdvisorProfile.vue?vue&type=script&lang=js"
import style0 from "./AdvisorProfile.vue?vue&type=style&index=0&id=a8cacf5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports